<nav class="top-nav">
  <div class="nav-container">
    <div class="nav-brand">
      <a routerLink="/"><img src="auctiondraftin-name-only-dark.png" alt="Welcome to Auction Draft" title="Welcome to Auction Draft"  /></a>
    </div>
    @if (user(); as user) {
      <div class="user-menu">
        <button
          class="user-menu-button"
          id="userMenuButton"
          [class.active]="isDropdownOpen()"
          (click)="toggleDropdown()">
          @if (user.profile_picture) {
            <img [src]="user.profile_picture" [alt]="user.name" class="user-avatar" referrerpolicy="no-referrer">
          }
          <span class="user-name">{{ user.name }}</span>
          <svg class="dropdown-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="user-menu-dropdown" id="userMenuDropdown" [class.show]="isDropdownOpen()">
          <a routerLink="/" class="dropdown-item" (click)="isDropdownOpen.set(false)">Home</a>
          <a routerLink="/leagues" class="dropdown-item" (click)="isDropdownOpen.set(false)">Leagues</a>
          <a routerLink="/collection" class="dropdown-item" (click)="isDropdownOpen.set(false)">Collection</a>
          <div class="dropdown-divider"></div>
          <a (click)="logout()" class="dropdown-item" style="cursor: pointer;">Logout</a>
        </div>
      </div>
    }
  </div>
</nav>
